<div class="login-container">
  <div class="background">
    <div class="gradient-overlay"></div>
    <div class="particles">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
    </div>
  </div>

  <div class="login-panel">
    <div class="login-panel-left">
      <div class="brand-logo">
        <svg viewBox="0 0 24 24" class="logo-icon">
          <path
            d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
          ></path>
        </svg>
        <span class="logo-text">Markado</span>
      </div>
      <div class="illustration">
        <div class="illustration-circle"></div>
        <div class="illustration-shape shape-1"></div>
        <div class="illustration-shape shape-2"></div>
        <div class="illustration-shape shape-3"></div>
      </div>
      <div class="welcome-text">
        <h1>Reset Password</h1>
        <p>Enter your email to receive a password reset link</p>
      </div>
    </div>

    <div class="login-panel-right">
      <div class="login-header">
        <h2>Forgot Password?</h2>
        <p>Don't worry, we'll send you a reset link</p>
      </div>

      <form
        [formGroup]="forgotPasswordForm"
        (ngSubmit)="onSubmit()"
        class="forgot-password-form login-form"
      >
        <div
          class="form-group"
          [class.form-error]="
            email?.invalid && (email?.dirty || email?.touched)
          "
        >
          <label for="email">Email</label>
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24">
              <path
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
              ></path>
            </svg>
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="you@example.com"
              [class.is-invalid]="
                email?.invalid && (email?.dirty || email?.touched)
              "
            />
          </div>
          <div
            class="error-text"
            *ngIf="email?.invalid && (email?.dirty || email?.touched)"
          >
            <div *ngIf="email?.errors?.['required']">Email is required</div>
            <div *ngIf="email?.errors?.['email']">
              Please enter a valid email address
            </div>
          </div>
        </div>

        <div class="form-group">
          <app-recaptcha
            (tokenChange)="onRecaptchaChange($event)"
            (error)="onRecaptchaError($event)"
            [errorMessage]="recaptchaErrorMessage"
          >
          </app-recaptcha>
        </div>

        <div class="alert alert-error" *ngIf="errorMessage">
          <svg class="alert-icon" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{{ errorMessage }}</span>
        </div>

        <div class="alert alert-success" *ngIf="successMessage">
          <svg class="alert-icon" viewBox="0 0 24 24">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <span>{{ successMessage }}</span>
        </div>

        <button
          type="submit"
          class="signin-button"
          [disabled]="
            isSubmitting || forgotPasswordForm.invalid || !recaptchaToken
          "
        >
          <span *ngIf="!isSubmitting">Send Reset Link</span>
          <div class="spinner" *ngIf="isSubmitting">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </button>

        <div class="signup-prompt">
          <span>Remember your password?</span>
          <a routerLink="/login" class="signup-link">Back to Login</a>
        </div>
      </form>
    </div>
  </div>
</div>
